import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  forgotPassword(data: any) {
    return this.http.post(`${environment.baseUrl}/user/v1/forgot-password`, data);
  }

  newPassword(data: any, token: string) {
    return this.http.patch(`${environment.baseUrl}/user/v1/reset-password?token=${token}`, data);
  }
}
